<div [id]="swiperContainerId" class="position-relative">
  <swiper-container #swiperContainer class="swiper">
    <ng-content></ng-content> 
  </swiper-container>
</div>